import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { ProjectModalMobile } from '../../../../components/ProjectModal';
import { ResponsiveImage } from '../../../../components/ResponsiveImage';
import { PhoneButtonContainer } from '../../../PhoneButtonContainer';
import { ScrollableSliderContainer } from '../../../ScrollableSliderContainer';
import { IProjectModalContainerBaseProps } from '../../types';
import { IImage } from '../../../../types/builder';
import { CallbackButtonContainer } from '../../../CallbackButtonContainer';
import { ECallbackWidgetPlacement } from '../../../../types/callbackWidget';
import { CallButtonContainer } from '../../../CallButtonContainer';

export type IProjectModalContainerMobileProps = IProjectModalContainerBaseProps;

export const ProjectModalContainerMobile: React.FC<IProjectModalContainerMobileProps> = ({
  onClose,
  onPhoneButtonClick,
  ...project
}) => {
  const deviceType = useDeviceType();

  const phoneButton =
    deviceType === 'phone' ? (
      <CallButtonContainer onClick={onPhoneButtonClick} />
    ) : (
      <PhoneButtonContainer withIcon onShow={onPhoneButtonClick} />
    );

  const renderSlide = (slide: IImage) => <ResponsiveImage src={slide.full} />;

  return (
    <ProjectModalMobile
      {...project}
      onClose={onClose}
      slider={<ScrollableSliderContainer slides={project.images} renderSlide={renderSlide} />}
      phoneButton={phoneButton}
      callbackButton={<CallbackButtonContainer placement={ECallbackWidgetPlacement.HouseGallery} />}
    />
  );
};
